import { Routes, Route, Navigate } from 'react-router-dom';

import AddDevice from './AddDevice';
import DeviceList from './DeviceList';
import EditDevice from './EditDevice';

const ManageDevice = () => {
  return (
    <Routes>
      {/* Default route: redirect to device-list */}
      <Route index element={<Navigate to="device-list" replace />} />

      {/* Nested routes */}
      <Route path="device-list" element={<DeviceList />} />
      <Route path="add-device" element={<AddDevice />} />
      <Route path="edit-device/:id" element={<EditDevice />} />
    </Routes>
  );
};

export default ManageDevice;